<template>
  <div class="search-form">
    <div class="d-flex">
      <div style="width:400px;" class="mb-2">
        <b-input-group size="sm">
          <b-form-input
            @keyup.enter="query"
            type="search"
            v-model.trim="form.keyword"
            placeholder="订单编号/客户/合同名称搜索..."
          />
          <b-input-group-append>
            <b-button-group>
              <b-button-group slot="reference">
                <b-button
                  variant="link"
                  size="sm"
                  class="search-dropdown-button"
                  squared
                  @click="openAdvqueryDialog"
                  >高级搜索</b-button
                >
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-button-group>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="mb-2">
        <b-input-group size="sm">
          <b-button
            v-allow="'actSettlement'"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="batchSumit()"
            >批量结算</b-button
          >
          <!-- 批量导出 -->
          <b-button
            size="sm"
            variant="outline-success"
            class="ml-2"
            v-allow="'actExport'"
            @click="$emit('batchExport')"
          >
            <i class="el-icon-folder-opened"></i>
            批量导出
          </b-button>
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            v-allow="'actBuilder'"
            @click="generateBill()"
            >生成账单
          </b-button>
        </b-input-group>
      </div>
    </div>

    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="订单编号">
              <el-input
                v-model="form.orderNo"
                placeholder="请输入订单编号"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称">
              <dict-select
                filterable
                style="width:100%"
                v-model="form.custCode"
                url="/master/customer/info/select"
                placeholder="请选择客户"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="订单类型">
              <dict-select
                filterable
                clearable
                v-model="form.orderType"
                placeholder="请选择订单类型"
                default
                :body="orderTypeDictParams"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="创建日期">
              <el-date-picker
                v-model="form.beginDate"
                type="date"
                size="small"
                :picker-options="dateStartPicker"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到" prop="endDate">
              <el-date-picker
                v-model="form.endDate"
                type="date"
                size="small"
                :picker-options="dateEndPicker"
                value-format="yyyy-MM-dd"
                placeholder="选择结束日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改日期">
              <el-date-picker
                v-model="form.modifyBeginDate"
                type="date"
                size="small"
                :picker-options="modifyDateStartPicker"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="到" prop="endDate">
              <el-date-picker
                v-model="form.modifyEndDate"
                type="date"
                size="small"
                :picker-options="modifyDateEndPicker"
                value-format="yyyy-MM-dd"
                placeholder="选择结束日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="创建人">
              <el-input
                v-model="form.createByName"
                placeholder="请输入名称"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="修改人">
              <el-input
                v-model="form.modifyByName"
                placeholder="请输入名称"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客户托运日期">
              <el-date-picker
                v-model="form.orderDateBegin"
                type="date"
                size="small"
                :picker-options="orderDateBeginPicker"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到">
              <el-date-picker
                v-model="form.orderDateEnd"
                type="date"
                size="small"
                :picker-options="orderDateEndPicker"
                value-format="yyyy-MM-dd"
                placeholder="选择结束日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog"
          >取消查询</el-button
        >
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>

    <generate-bill
      v-if="generateBillVisible"
      :visible.sync="generateBillVisible"
      @reload="() => $emit('reload')"
    />
  </div>
</template>
<script>
// 初始表单
const initForm = {
  keyword: '',
  settlementStatusList: ['N'],
}
import GenerateBill from '../generate-bill'
export default {
  components: { GenerateBill },
  data() {
    return {
      //订单类型下拉请求参数
      orderTypeDictParams: { type: 'orderType' },
      form: { ...initForm },
      advqueryDialogVisible: false,
      dateStartPicker: this.dateEnd(),
      modifyDateStartPicker: this.modifyDateEnd(),
      dateEndPicker: this.dateStart(),
      modifyDateEndPicker: this.modifyDateStart(),
      orderDateBeginPicker: this.orderDateEnd(),
      orderDateEndPicker: this.orderDateBegin(),
      generateBillVisible: false,
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    batchSumit() {
      this.$emit('batchSumit')
    },
    generateBill() {
      this.generateBillVisible = true
    },
    modifyDateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyEndDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.modifyEndDate).getTime() < time.getTime()
          }
        },
      }
    },
    modifyDateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyBeginDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.modifyBeginDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    //时间限制
    dateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endDate).getTime() < time.getTime()
          }
        },
      }
    },
    dateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    orderDateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.orderDateEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.orderDateEnd).getTime() < time.getTime()
          }
        },
      }
    },
    orderDateBegin() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.orderDateBegin) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.orderDateBegin).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
